import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=4fd3caaa&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd3caaa')) {
      api.createRecord('4fd3caaa', component.options)
    } else {
      api.reload('4fd3caaa', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=4fd3caaa&", function () {
      api.rerender('4fd3caaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dHUfjyR7T4PZ/JS/pricehelp.vue"
export default component.exports